{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0, 1, 2, 3]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube",
			"rotation": [0.9932466745376587, -0.11602167785167694, 0, 0],
			"scale": [-0.07651010900735855, -0.7886501550674438, -0.6736917495727539],
			"translation": [-0.8370531797409058, 2.4596433639526367, 0]
		},
		{
			"mesh": 1,
			"name": "Cube.001",
			"rotation": [0.9932467937469482, 0.11602156609296799, 0, 0],
			"scale": [-0.07651010900735855, -0.7886501550674438, -0.6736917495727539],
			"translation": [0.8227914571762085, 2.4309797286987305, 0]
		},
		{
			"mesh": 2,
			"name": "Cube.003",
			"rotation": [0, 0, -0.022966518998146057, 0.9997363090515137],
			"scale": [-0.07895159721374512, -0.04801219701766968, -0.07895159721374512],
			"translation": [-0.6507440805435181, 3.233491897583008, 0.5580189824104309]
		},
		{
			"mesh": 3,
			"name": "Cube.004",
			"rotation": [0, 0, -0.022966518998146057, 0.9997363090515137],
			"scale": [-0.07895159721374512, -0.04801219701766968, -0.07895159721374512],
			"translation": [-0.6507440805435181, 3.233491897583008, -0.5580185651779175]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.001",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.01434984989464283, 1, 1, 1],
				"metallicFactor": 0.5039370059967041,
				"roughnessFactor": 0.27952754497528076
			}
		},
		{
			"doubleSided": true,
			"name": "Material",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.28494957089424133, 0.02045438624918461, 0.8034002780914307, 1],
				"metallicFactor": 0.5590550899505615,
				"roughnessFactor": 0.16141733527183533
			}
		},
		{
			"doubleSided": true,
			"name": "Material.004",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.8755569458007812, 0, 0.31318700313568115, 1],
				"metallicFactor": 0.4645669162273407,
				"roughnessFactor": 0.3897637724876404
			}
		},
		{
			"doubleSided": true,
			"name": "Material.006",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0, 0.7078190445899963, 0.14296753704547882, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		}
	],
	"meshes": [
		{
			"name": "Cube.010",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 1
				},
				{
					"attributes": {
						"POSITION": 8,
						"NORMAL": 9,
						"TEXCOORD_0": 10
					},
					"indices": 11,
					"material": 2
				}
			]
		},
		{
			"name": "Cube.012",
			"primitives": [
				{
					"attributes": {
						"POSITION": 12,
						"NORMAL": 13,
						"TEXCOORD_0": 14
					},
					"indices": 15,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 16,
						"NORMAL": 17,
						"TEXCOORD_0": 18
					},
					"indices": 19,
					"material": 2
				},
				{
					"attributes": {
						"POSITION": 20,
						"NORMAL": 21,
						"TEXCOORD_0": 22
					},
					"indices": 23,
					"material": 1
				}
			]
		},
		{
			"name": "Cube.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 24,
						"NORMAL": 25,
						"TEXCOORD_0": 26
					},
					"indices": 27,
					"material": 3
				}
			]
		},
		{
			"name": "Cube.004",
			"primitives": [
				{
					"attributes": {
						"POSITION": 28,
						"NORMAL": 29,
						"TEXCOORD_0": 30
					},
					"indices": 27,
					"material": 3
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 28,
			"max": [1.8656467199325562, 1.0176132917404175, 1],
			"min": [-1.0976765155792236, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 28,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 28,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 84,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 41,
			"max": [1.938742756843567, 1.0176132917404175, 1],
			"min": [-1.0976765155792236, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 41,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 41,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 84,
			"type": "SCALAR"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 26,
			"max": [1, 0.9599920511245728, 1],
			"min": [-1.0976765155792236, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 26,
			"type": "VEC3"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 26,
			"type": "VEC2"
		},
		{
			"bufferView": 11,
			"componentType": 5123,
			"count": 60,
			"type": "SCALAR"
		},
		{
			"bufferView": 12,
			"componentType": 5126,
			"count": 28,
			"max": [1, 0.9599920511245728, 1],
			"min": [-2.121184825897217, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 13,
			"componentType": 5126,
			"count": 28,
			"type": "VEC3"
		},
		{
			"bufferView": 14,
			"componentType": 5126,
			"count": 28,
			"type": "VEC2"
		},
		{
			"bufferView": 15,
			"componentType": 5123,
			"count": 84,
			"type": "SCALAR"
		},
		{
			"bufferView": 16,
			"componentType": 5126,
			"count": 38,
			"max": [1, 0.9599920511245728, 1],
			"min": [-2.121184825897217, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 17,
			"componentType": 5126,
			"count": 38,
			"type": "VEC3"
		},
		{
			"bufferView": 18,
			"componentType": 5126,
			"count": 38,
			"type": "VEC2"
		},
		{
			"bufferView": 19,
			"componentType": 5123,
			"count": 84,
			"type": "SCALAR"
		},
		{
			"bufferView": 20,
			"componentType": 5126,
			"count": 32,
			"max": [0.9023234248161316, 0.9599920511245728, 1],
			"min": [-2.121184825897217, -0.9890925884246826, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 21,
			"componentType": 5126,
			"count": 32,
			"type": "VEC3"
		},
		{
			"bufferView": 22,
			"componentType": 5126,
			"count": 32,
			"type": "VEC2"
		},
		{
			"bufferView": 23,
			"componentType": 5123,
			"count": 60,
			"type": "SCALAR"
		},
		{
			"bufferView": 24,
			"componentType": 5126,
			"count": 60,
			"max": [1, 1, 1],
			"min": [-17.352807998657227, -1.5645831823349, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 25,
			"componentType": 5126,
			"count": 60,
			"type": "VEC3"
		},
		{
			"bufferView": 26,
			"componentType": 5126,
			"count": 60,
			"type": "VEC2"
		},
		{
			"bufferView": 27,
			"componentType": 5123,
			"count": 108,
			"type": "SCALAR"
		},
		{
			"bufferView": 28,
			"componentType": 5126,
			"count": 60,
			"max": [1, 1, 1],
			"min": [-17.352807998657227, -1.5645831823349, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 29,
			"componentType": 5126,
			"count": 60,
			"type": "VEC3"
		},
		{
			"bufferView": 30,
			"componentType": 5126,
			"count": 60,
			"type": "VEC2"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 336,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 336,
			"byteOffset": 336,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 224,
			"byteOffset": 672,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 168,
			"byteOffset": 896,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 492,
			"byteOffset": 1064,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 492,
			"byteOffset": 1556,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 328,
			"byteOffset": 2048,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 168,
			"byteOffset": 2376,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 312,
			"byteOffset": 2544,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 312,
			"byteOffset": 2856,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 208,
			"byteOffset": 3168,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 120,
			"byteOffset": 3376,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 336,
			"byteOffset": 3496,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 336,
			"byteOffset": 3832,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 224,
			"byteOffset": 4168,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 168,
			"byteOffset": 4392,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 456,
			"byteOffset": 4560,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 456,
			"byteOffset": 5016,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 304,
			"byteOffset": 5472,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 168,
			"byteOffset": 5776,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 5944,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 384,
			"byteOffset": 6328,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 256,
			"byteOffset": 6712,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 120,
			"byteOffset": 6968,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 720,
			"byteOffset": 7088,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 720,
			"byteOffset": 7808,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 480,
			"byteOffset": 8528,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 216,
			"byteOffset": 9008,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 720,
			"byteOffset": 9224,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 720,
			"byteOffset": 9944,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 480,
			"byteOffset": 10664,
			"target": 34962
		}
	],
	"buffers": [
		{
			"byteLength": 11144,
			"uri": "gamer%20armor.bin"
		}
	]
}
